var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5355 27.1039C18.6464 23.3412 23.9828 13.466 23.9828 9.79217C23.9828 5.21253 20.2702 1.5 15.6906 1.5C11.111 1.5 7.39844 5.21253 7.39844 9.79217C7.39844 13.466 12.7348 23.3412 14.8458 27.1039C15.2205 27.7718 16.1607 27.7718 16.5355 27.1039ZM20.1692 7.41592C20.296 7.54564 20.3579 7.70338 20.3549 7.88912C20.352 8.06897 20.2856 8.22376 20.1559 8.35348L15.2248 13.1298C15.1364 13.2123 15.0332 13.2683 14.9153 13.2978C14.7973 13.3244 14.6809 13.3199 14.5659 13.2846C14.448 13.2492 14.3492 13.1873 14.2696 13.0988L12.3591 10.9716C12.2352 10.833 12.1792 10.6723 12.191 10.4895C12.1999 10.3068 12.2721 10.1549 12.4077 10.034C12.5433 9.9102 12.7025 9.85418 12.8853 9.86598C13.0681 9.87482 13.2214 9.94705 13.3453 10.0827L14.7959 11.6969L19.2316 7.40265C19.3613 7.27292 19.5191 7.20953 19.7048 7.21248C19.8847 7.21543 20.0395 7.28324 20.1692 7.41592Z",
    fill: "#84CC16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLocation);
export default __webpack_public_path__ + "static/media/TotalLocation.7bc253727707723e21a110cf6e600acf.svg";
export { ForwardRef as ReactComponent };